import React, { useEffect, useState } from 'react';
import ReactImageGallery from 'react-image-gallery';

import { FormattedMessage } from '../../util/reactIntl';
import { ResponsiveImage, Modal, IconArrowHead } from '../../components';

import ImageCarousel from './ImageCarousel/ImageCarousel';
import './ImageCarousel/image-gallery.css';

import css from './ListingPage.module.css';

const SectionHero = props => {
  const [mounted, setMounted] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  
  useEffect(() => {
    setMounted(true);
  }, []);

  const {
    title,
    listing,
    isOwnListing,
    handleViewPhotosClick,
    imageCarouselOpen,
    onImageCarouselClose,
    onManageDisableScrolling,
    actionBar,
  } = props;

  const hasImages = listing.images && listing.images.length > 0;
  const firstImage = hasImages ? listing.images[0] : null;
  const variants = firstImage
    ? Object.keys(firstImage?.attributes?.variants).filter(k => k.startsWith('scaled'))
    : [];

  const viewPhotosButton = hasImages ? (
    <button className={css.viewPhotos} onClick={handleViewPhotosClick}>
      <FormattedMessage
        id="ListingPage.viewImagesButton"
        values={{ count: listing.images.length }}
      />
    </button>
  ) : null;

  // Mobile carousel items
  const carouselItems = hasImages
    ? listing.images.map((img, i) => ({
        original: '',
        image: img,
        alt: `${title} - Image ${i + 1}`,
      }))
    : [];

  const renderCarouselItem = item => {
    const imageVariants = item.image?.attributes?.variants
      ? Object.keys(item.image.attributes.variants).filter(k => k.startsWith('scaled'))
      : [];
    
    return (
      <div className={css.mobileCarouselImageWrapper}>
        <ResponsiveImage
          rootClassName={css.mobileCarouselImage}
          alt={item.alt}
          image={item.image}
          variants={imageVariants}
        />
      </div>
    );
  };

  const renderLeftNav = (onClick, disabled) => {
    return (
      <button className={css.mobileNavLeft} disabled={disabled} onClick={onClick}>
        <IconArrowHead direction="left" size="small" className={css.mobileArrowHead} />
      </button>
    );
  };

  const renderRightNav = (onClick, disabled) => {
    return (
      <button className={css.mobileNavRight} disabled={disabled} onClick={onClick}>
        <IconArrowHead direction="right" size="small" className={css.mobileArrowHead} />
      </button>
    );
  };

  const handleSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <section className={css.sectionHero} data-testid="hero">
      {/* Desktop: single image with click to open modal */}
      <div className={css.imageWrapperForSectionHero} onClick={handleViewPhotosClick}>
        {mounted && listing.id && isOwnListing ? (
          <div onClick={e => e.stopPropagation()} className={css.actionBarContainerForHeroLayout}>
            {actionBar}
          </div>
        ) : null}

        <ResponsiveImage
          rootClassName={css.rootForImage}
          alt={title}
          image={firstImage}
          variants={variants}
        />
        {viewPhotosButton}
      </div>

      {/* Mobile: swipable carousel */}
      {hasImages && carouselItems.length > 0 ? (
        <div className={css.mobileCarouselWrapper}>
          {mounted && listing.id && isOwnListing ? (
            <div className={css.actionBarContainerForMobileCarousel}>
              {actionBar}
            </div>
          ) : null}
          
          <ReactImageGallery
            additionalClass={css.mobileCarouselGallery}
            items={carouselItems}
            renderItem={renderCarouselItem}
            renderLeftNav={renderLeftNav}
            renderRightNav={renderRightNav}
            onSlide={handleSlide}
            showPlayButton={false}
            showFullscreenButton={false}
            showThumbnails={false}
            showNav={carouselItems.length > 1}
            showBullets={false}
            slideDuration={350}
            swipingTransitionDuration={350}
          />
          
          {/* Always show counter */}
          <div className={css.mobileImageCounter}>
            {currentIndex + 1}/{carouselItems.length}
          </div>
        </div>
      ) : null}
      <Modal
        id="ListingPage.imageCarousel"
        scrollLayerClassName={css.carouselModalScrollLayer}
        containerClassName={css.carouselModalContainer}
        lightCloseButton
        isOpen={imageCarouselOpen}
        onClose={onImageCarouselClose}
        usePortal
        onManageDisableScrolling={onManageDisableScrolling}
      >
        <ImageCarousel
          images={listing.images}
          imageVariants={['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge']}
        />
      </Modal>
    </section>
  );
};

export default SectionHero;
